<div class="modal-header"><h3 class="modal-title">File Preview {{file?.name}}</h3></div>
<div class="modal-body content">
  <div class="lds-roller" *ngIf="isSpinnerActive">
    <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
  </div>
  <ngx-doc-viewer
    *ngIf="viewerType === viewerTypes.DOC_VIEWER"
    [url]="fileLink"
    [viewer]="isPdf ? 'url' : 'google'"
    class="preview-doc"
    [googleCheckInterval]="4000"
    (loaded)="hideSpinner()"
  ></ngx-doc-viewer>
  <div class="preview-image-section"
       [class.preview-image-section-original]="isImageFullHeight"
       *ngIf="viewerType === viewerTypes.IMAGE_VIEWER"
  >
    <button class="image-btn" (click)="changeImageSize()">
      <i class="fa fa-expand" [ngClass]="isImageFullHeight ? 'fa-expand' : 'fa-compress'"></i>
    </button>
    <div class="preview-image-wrapper">
      <img class="preview-image" [class.preview-image-full]="isImageFullHeight" [src]="fileLink" />
    </div>
  </div>
  <p *ngIf="viewerType === viewerTypes.UNSUPPORTED_VIEWER">Unsupported file type</p>
</div>
<div class="modal-footer">
  <button class="btn btn-default" (click)="close()">Close</button>
  <button class="btn btn-primary" (click)="openNewWindow(fileLink)">{{isPdf ? 'Open in Full-Screen' : 'Download'}}</button>
</div>


